import { Controller } from '@hotwired/stimulus';

// Opens and closes a collapsible panel, such as the mobile menu. Style the open state with group-data-open.
// With an open and close label, the button's aria-label follows the state.
export default class extends Controller {
    static targets = ['button'];
    static values = { openLabel: String, closeLabel: String };

    toggle() {
        this.setOpen(!this.isOpen);
    }

    close() {
        this.setOpen(false);
    }

    closeOnEscape() {
        if (!this.isOpen) {
            return;
        }

        this.close();
        this.buttonTarget.focus();
    }

    // Also leaves the page closed in the back-forward cache
    closeAfterLinkClick(event) {
        if (event.target.closest('a')) {
            this.close();
        }
    }

    get isOpen() {
        return this.element.hasAttribute('data-open');
    }

    setOpen(isOpen) {
        this.element.toggleAttribute('data-open', isOpen);
        this.buttonTarget.setAttribute('aria-expanded', String(isOpen));
        if (this.hasOpenLabelValue && this.hasCloseLabelValue) {
            this.buttonTarget.setAttribute('aria-label', isOpen ? this.closeLabelValue : this.openLabelValue);
        }
    }
}
